import React from "react";
import { Equipment } from "../models/EquipmentTypes";

interface EquipmentDetailProps {
  equipment: Equipment;
  onClose: () => void;
}

const EquipmentDetail: React.FC<EquipmentDetailProps> = ({ equipment, onClose }) => {
  return (
    <div className="ee-modal-overlay" onClick={onClose}>
      <div className="ee-modal" onClick={(e) => e.stopPropagation()}>
        <div className="ee-modal-header">
          <h2>Equipment Details</h2>
          <button className="ee-modal-close" onClick={onClose}>&times;</button>
        </div>

        <div className="ee-modal-content">
          <section className="ee-modal-section">
            <h3>General Information</h3>
            <div className="ee-detail-grid">
              <div className="ee-detail-item">
                <label>Equipment Name:</label>
                <span>{equipment.equipment_name || "-"}</span>
              </div>
              <div className="ee-detail-item">
                <label>Equipment ID:</label>
                <span>{equipment.equipment_id || "-"}</span>
              </div>
              <div className="ee-detail-item">
                <label>Latis ID:</label>
                <span>{equipment.equipment_latis_id || "-"}</span>
              </div>
              <div className="ee-detail-item">
                <label>Serial Number:</label>
                <span>{equipment.equipment_serial_number || "-"}</span>
              </div>
              <div className="ee-detail-item">
                <label>Controller ID:</label>
                <span>{equipment.equipment_controller_id || "-"}</span>
              </div>
              <div className="ee-detail-item">
                <label>Status:</label>
                <span className={`ee-status ee-status-${equipment.functional_object_status === 'customfo' ? 'customfo' : equipment.functional_object_status}`}>
                  {equipment.functional_object_status || "-"}
                </span>
              </div>
            </div>
          </section>

          <section className="ee-modal-section">
            <h3>Location</h3>
            <div className="ee-detail-grid">
              <div className="ee-detail-item">
                <label>Location Name:</label>
                <span>{equipment.location_name || "-"}</span>
              </div>
              <div className="ee-detail-item">
                <label>Location ID:</label>
                <span>{equipment.location_id || "-"}</span>
              </div>
              <div className="ee-detail-item">
                <label>Latis Location ID:</label>
                <span>{equipment.location_latis_id || "-"}</span>
              </div>
              <div className="ee-detail-item">
                <label>Country:</label>
                <span>{equipment.location_country_code || "-"}</span>
              </div>
              <div className="ee-detail-item">
                <label>Business Unit:</label>
                <span>{equipment.business_unit || "-"}</span>
              </div>
            </div>
          </section>

          <section className="ee-modal-section">
            <h3>Product</h3>
            <div className="ee-detail-grid">
              <div className="ee-detail-item">
                <label>Product Family:</label>
                <span>{equipment.product_family_name || "-"}</span>
              </div>
              <div className="ee-detail-item">
                <label>Product Name:</label>
                <span>{equipment.product_name || "-"}</span>
              </div>
              <div className="ee-detail-item">
                <label>Product Model:</label>
                <span>{equipment.product_model_name || "-"}</span>
              </div>
              <div className="ee-detail-item">
                <label>Connectivity:</label>
                <span>{equipment.connectivity_name || "-"}</span>
              </div>
            </div>
          </section>

          {equipment.technology_fields && equipment.technology_fields.length > 0 && (
            <section className="ee-modal-section">
              <h3>Technology Fields</h3>
              <div className="ee-tech-fields">
                {equipment.technology_fields.map((field, idx) => (
                  <div key={idx} className="ee-tech-field">
                    <span className="ee-tech-key">{field.key}</span>
                    <span className="ee-tech-value">{String(field.value)}</span>
                    <span className="ee-tech-type">{field.type}</span>
                  </div>
                ))}
              </div>
            </section>
          )}

          {equipment.edt_fields && equipment.edt_fields.length > 0 && (
            <section className="ee-modal-section">
              <h3>EDT Fields ({equipment.edt_fields.length})</h3>
              <div className="ee-edt-fields">
                {equipment.edt_fields.map((field, idx) => (
                  <div key={idx} className="ee-edt-field">
                    <div className="ee-edt-header">
                      <span className="ee-edt-key">{field.var_name || field.title}</span>
                      <span className="ee-edt-type">{field.data_type}</span>
                    </div>
                    <span className="ee-edt-desc">{field.description || '-'}</span>
                    {field.configs && field.configs.length > 0 && (
                      <div className="ee-edt-configs">
                        {field.configs.map((config, cidx) => (
                          <div key={cidx} className={`ee-edt-config ee-edt-config-${config.color?.toLowerCase() || 'default'}`}>
                            <span className="ee-edt-bit">Bit {config.bit}</span>
                            <span className="ee-edt-config-title">{config.title}</span>
                            <span className="ee-edt-config-desc">{config.description || '-'}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </section>
          )}
        </div>
      </div>
    </div>
  );
};

export default EquipmentDetail;